import { FC, useCallback } from 'react';
import { useFragment, useMutation } from 'react-relay';
import { Formik } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import Form from 'components/Form';
import AccordionController from 'components/AccordionController';
import Section from 'components/Section';
import TextField from 'components/TextField';

import { useErrorHandler } from 'lib';
import { CityEditFormMutation } from '__generated__/CityEditFormMutation.graphql';
import { CityEditForm_city$key } from '__generated__/CityEditForm_city.graphql';

type FormValues = {
  name: string;
};

type Props = {
  city: CityEditForm_city$key;
};

const CityEditForm: FC<Props> = props => {
  const errorHandler = useErrorHandler();

  const { id, ...initial } = useFragment(
    graphql`
      fragment CityEditForm_city on City {
        id
        name
      }
    `,
    props.city
  );

  const [update, updating] = useMutation<CityEditFormMutation>(graphql`
    mutation CityEditFormMutation($input: UpdateCityInput!) {
      updateCity(input: $input) {
        ...CityEditForm_city
        ...CitySidebar_city
      }
    }
  `);

  const handleSubmit = useCallback(
    (input: FormValues) => {
      update({
        variables: {
          input: {
            id,
            ...input,
          },
        },

        ...errorHandler({
          successMessage: 'Išsaugota',
        }),
      });
    },
    [errorHandler, id, update]
  );

  return (
    <Formik<FormValues> initialValues={initial} onSubmit={handleSubmit}>
      <Form loading={updating}>
        <AccordionController id="cityMain">
          <Section title="Apie" id="general">
            <Stack spacing={4}>
              <TextField name="name" label="Pavadinimas" />
            </Stack>
          </Section>
        </AccordionController>
      </Form>
    </Formik>
  );
};

export default CityEditForm;
